import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addPartySetting = (party_series,address_series) => {
  return axios.post(API + "company/company-settings/", {
    party_series,
    address_series
  },{headers: authHeader(),});
};
const AddPartySettingService = {
    addPartySetting,
    
  };
  export default AddPartySettingService;